import { ComponentPropsWithoutRef } from 'react';
import { Link } from 'react-router-dom';

import {
  Theme,
  Typography,
  WithStyles,
  createStyles,
  withStyles,
} from '@material-ui/core';

import classNames from 'classnames';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      alignItems: 'center',
      minWidth: 190,
      [theme.breakpoints.down('sm')]: {
        minWidth: 40,
      },
      gap: theme.spacing(2),
    },
    text: {
      [theme.breakpoints.down('xs')]: {
        display: 'none',
      },
    },
  });

export interface AppHeaderBrandProps
  extends ComponentPropsWithoutRef<typeof Link>,
    WithStyles<typeof styles> {
  icon?: React.ReactNode;
  text?: React.ReactNode;
}

const AppHeaderBrand = (props: AppHeaderBrandProps) => {
  const { to = '/', children, className, classes, icon, text, ...rest } = props;
  return (
    <Link
      to={to}
      aria-label="Home"
      color="inherit"
      className={classNames(classes.root, className)}
      {...rest}
    >
      {icon}
      {text && (
        <Typography variant="h6" component="h1" className={classes.text}>
          {text}
        </Typography>
      )}
    </Link>
  );
};

export default withStyles(styles, { name: 'AppHeaderBrand' })(AppHeaderBrand);
